import { useCallback, useEffect, useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, AppState } from "store/configureStore";
import { getDmsSettings } from "store/slices/settings";
import TenantCompanySelector from "./TenantCompanySelector";
import DmsSettingsModal from "./DmsSettingsModal";
import TenantUsersModal from "./TenantUserModal";
import Tenant from "entities/Tenant";


const SettingsPaySettingsPage = () => {
    const { t } = useTranslation("parts");
    const dispatch = useDispatch<AppDispatch>();
    const [selectedTenantId, setSelectedTenantId] = useState<number | null>(null);
    const [selectedTenant, setSelectedTenant] = useState<Tenant | null>(null);

    const { data: dmsSettings, loading: dmsSettingsLoading } = useSelector((state: AppState) => state.entities.settings.dmsSettings);
    const { list: tenants, loading: tenantsLoading } = useSelector((state: AppState) => state.admin.tenantWideData.tenants);
    const [isDmsModalOpen, setIsDmsModalOpen] = useState<boolean>(false);
    const [isManageAdminUserModalOpen, setIsManageAdminUserModalOpen] = useState<boolean>(false);

    useEffect(() => {
        if (selectedTenantId) {
            dispatch(getDmsSettings(selectedTenantId));
        }
    }, [dispatch, selectedTenantId]);


    useEffect(() => {
        if (!tenantsLoading && tenants.length > 0 && selectedTenantId !== null) {
            setSelectedTenant(tenants.find(t => t.Id === selectedTenantId) || null);
        }
    }, [tenantsLoading, tenants, selectedTenantId]);

    const handleAdminUsers = () => {
        setIsManageAdminUserModalOpen(true);
    }

    const handleTenantSelectionChange = useCallback((tenantId: number | null, companyId: number | null) => {
        setSelectedTenantId(tenantId);
    }, [])

    const handleDmsChange = () => {
        setIsDmsModalOpen(true);
    };

    return (
        <div className="settings-card card">
            <h2>{t("settings.paySettings.heading")}</h2>
            <div>
                <Button variant="primary" onClick={handleAdminUsers} className="mb-3">
                    {t("settings.manageAdminUsers")}
                </Button>
            </div>
            <div className="settings-body-card inline-card">
                <TenantCompanySelector
                    generalCompanyOption={true}
                    selectOnlyTenant={true}
                    onSelectionChange={handleTenantSelectionChange}
                />
                {/* <span className="card-info-text">{t("settings.paySettings.specificCompanyConfWarning")}</span> */}
            </div>
            <Row className="mb-3">
                <Col sm={6}>
                    <Card className="settings-body-card">
                        <Card.Header>DMS {t("settings.paySettings.parameters")}</Card.Header>
                        {dmsSettingsLoading ? (
                            <span>DMS Settings Loading...</span>
                        ) : (<>
                            <Card.Body>
                                {dmsSettings ? (
                                    Object.entries(dmsSettings).map(([key, value]) => (
                                        <div key={key} className="mb-3">
                                            <h6 className="mb-0">{t(`settings.dmsParameters.${key}`)}</h6>
                                            <span>{value || "-"}</span>
                                        </div>
                                    ))
                                ) : (
                                    <p>No DMS settings available</p>
                                )}
                            </Card.Body>
                            <Card.Footer>
                                <Button variant="primary" onClick={handleDmsChange} className="mb-2">{t("common:form.buttons.edit")}</Button>
                            </Card.Footer>
                        </>)}
                    </Card>
                </Col>
                <Col sm={6}>

                </Col>
                {/* <Button variant="primary" onClick={handleSave} className="mb-2">{t("settings.saveSettings")}</Button> */}
            </Row>

            <DmsSettingsModal
                show={isDmsModalOpen}
                onHide={() => setIsDmsModalOpen(false)}
                dmsSettings={dmsSettings}
                tenantId={selectedTenantId || -1}
            />

            <TenantUsersModal
                show={isManageAdminUserModalOpen}
                onHide={() => { setIsManageAdminUserModalOpen(false) }}
                tenant={selectedTenant}
                manageSAUsers={false}
            />
        </div>
    );
};

export default SettingsPaySettingsPage;